import { type ReactNode } from 'react'
import { Head } from '@inertiajs/react'
import cn from '@components/utils/cn'
import Icon, { type IconTypes } from '@components/utils/Icon'

export type PageHeaderProps = {
  heading: string
  icon?: IconTypes
  subtitle?: ReactNode
  actions?: ReactNode
  search?: ReactNode
  nav?: ReactNode
  documentTitle?: boolean
}

export function PageHeader({ heading, icon, subtitle, actions, search, nav, documentTitle = true }: PageHeaderProps) {
  return (
    <>
      {documentTitle && <Head title={heading} />}
      <header
        className={cn(
          'tw:relative tw:border-b tw:border-gray-cool-200 tw:bg-gray-cool-50 tw:px-6 tw:pt-8 tw:pb-6',
          search && 'tw:mb-6 tw:pb-20',
          !search && !nav && 'tw:mb-2'
        )}
      >
        <div className="tw:flex tw:flex-wrap tw:items-center tw:justify-between tw:gap-4">
          <div className="tw:flex tw:items-center tw:gap-3">
            {icon && (
              <span className="tw:flex tw:h-12 tw:w-12 tw:shrink-0 tw:items-center tw:justify-center tw:rounded-xl tw:bg-primary-100 tw:text-primary-600">
                <Icon type={icon} className="tw:h-6 tw:w-6" />
              </span>
            )}
            <div>
              <h1 className="tw:text-2xl tw:font-bold tw:text-gray-cool-800">{heading}</h1>
              {subtitle && <p className="tw:-mt-0.5 tw:text-sm tw:text-gray-cool-600">{subtitle}</p>}
            </div>
          </div>
          {actions && <div className="tw:flex tw:flex-wrap tw:items-center tw:gap-2">{actions}</div>}
        </div>
        {search && <div className="tw:absolute tw:inset-x-6 tw:bottom-0 tw:z-10 tw:translate-y-6">{search}</div>}
      </header>
      {nav && <div className="tw:mb-2 tw:border-b tw:border-gray-cool-200 tw:bg-white tw:px-6">{nav}</div>}
    </>
  )
}
